import { RISK_STATUS } from '../shared/reputation-risk-status';

const getRiskStatus = ({isDomainBlacklisted, riskScore}) => {
    if (isDomainBlacklisted) {
        return RISK_STATUS.HIGH;
    }

    if (riskScore > 20) {
        return RISK_STATUS.MEDIUM;
    }

    return RISK_STATUS.LOW;
};

const urlReputationMapper = {
    toDomain(data) {
        return {
            type: 'url',
            riskStatus: getRiskStatus(data),
            riskScore: data.riskScore,
            isDomainBlacklisted: data.isDomainBlacklisted,
            isRiskyDomainCategory: data.isRiskyDomainCategory,
            isValidHttps: data.isValidHttps,
            isUrlAccessible: data.isUrlAccessible,
            isLikelyPhishing: data.isLikelyPhishing,
            containsCreditCardField: data.containsCreditCardField,
            containsPasswordField: data.containsPasswordField,
            isSuspiciousDomain: data.isSuspiciousDomain
        }
    }
};

export {
    urlReputationMapper
};
